import { ComponentType } from '@angular/cdk/portal';
import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, NgZone, PLATFORM_ID } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MAT_SNACK_BAR } from 'src/app/common/utils/helpers';

@Injectable({ providedIn: 'root' })
export class OpenSnackBarService {
  constructor(
    @Inject(MAT_SNACK_BAR) private snackBar: MatSnackBar,
    @Inject(PLATFORM_ID) private platformId: any,
    private zone: NgZone,
  ) {}
  openSnackBar<T, D = any>(dialogClass: ComponentType<T>, config?: MatSnackBarConfig<D>) {
    if (isPlatformBrowser(this.platformId)) {
      const defaultOption: MatSnackBarConfig<D & { text: string }> = {
        verticalPosition: 'bottom',
        horizontalPosition: 'center',
        direction: 'ltr',
      };
      Object.assign(defaultOption, config);
      if (defaultOption.data.text !== 'ERROR_FROM_CAPACITOR') {
        return this.zone.run(() => {
          const snackBarRef = this.snackBar.openFromComponent<T, D>(dialogClass, {
            ...defaultOption,
            panelClass: [...(defaultOption.panelClass || []), 'panel_animated--snack', 'sharry-snack-bar'],
          });
          return snackBarRef;
        });
      }
      return null;
    }
    return null;
  }
}
